import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArDJ: CultureInfo = {
  name: 'ar-DJ',
  displayName: 'العربية (جيبوتي)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-DJ',
  parent: CultureInfoAr
};
